import { Box, ChakraProvider } from "@chakra-ui/react"
import queryClient from "api/queryClient"
import { AppLayout } from "component/AppLayout"
import { ChatClassifier } from "component/chat/ChatClassifier"
import EditPromptForm from "component/EditPromptForm"
import ChatDB from "component/chat/ChatDB"
import { ChatDocs } from "component/chat/ChatDocs"
import { ChatKnowledgeBase } from "component/chat/ChatKnowledgeBase"
import { ChatQAOrdersAssistant } from "component/chat/ChatQAOrdersAssistant"
import { DemoSolution } from "component/demo/DemoSolution"
import { HomeRedirect } from "component/HomeRedirect"
import { RouteGuard } from "component/RouteGuard"
import { UpdateBanner } from "component/UpdateBanner"
import { AuthContextProvider } from "context/authContext"
import { FavoriteMessageContextProvider } from "context/favoriteMessageContext"
import { ModeContextProvider } from "context/modeContext"
import { SidebarContextProvider } from "context/sidebarContext"
import { UserContextProvider } from "context/userContext"
import { CallsAnalysis } from "page/CallsAnalysis"
import { MappingIterationResults } from "page/MappingIterationResults"
import { MappingIterations } from "page/MappingIterations"
import { QAOrdersKnowledgeBase } from "page/QAOrdersKnowledgeBase"
import { QueryClientProvider } from "react-query"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import { theme } from "theme"

import "react-toastify/dist/ReactToastify.css"

export const App = () => {
  return (
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <AuthContextProvider>
          <QueryClientProvider client={queryClient}>
            <UserContextProvider>
              <ModeContextProvider>
                <FavoriteMessageContextProvider>
                  <SidebarContextProvider>
                    {/* Каждая страница — в RouteGuard: заблокированные в сайдбаре
                        не открываются и по прямой ссылке (кроме админов).
                        Страницы вне сайдбара — только админам */}
                    <Routes>
                      <Route
                        path="/calls-analysis"
                        element={
                          <RouteGuard>
                            <CallsAnalysis />
                          </RouteGuard>
                        }
                      />

                      <Route element={<AppLayout />}>
                        <Route index element={<HomeRedirect />} />
                        <Route
                          path="/admin"
                          element={
                            <RouteGuard>
                              <Box mt={40}>
                                <EditPromptForm />
                              </Box>
                            </RouteGuard>
                          }
                        />
                        <Route
                          path="/databases"
                          element={
                            <RouteGuard url="databases">
                              <ChatDB />
                            </RouteGuard>
                          }
                        />
                        <Route
                          path="/documents"
                          element={
                            <RouteGuard url="documents">
                              <ChatDocs />
                            </RouteGuard>
                          }
                        />
                        <Route
                          path="/knowledge_base"
                          element={
                            <RouteGuard>
                              <ChatKnowledgeBase />
                            </RouteGuard>
                          }
                        />
                        <Route
                          path="/orders_qa"
                          element={
                            <RouteGuard url="orders_qa">
                              <ChatQAOrdersAssistant />
                            </RouteGuard>
                          }
                        />
                        <Route
                          path="/qa-orders-knowledge-base"
                          element={
                            <RouteGuard url="qa-orders-knowledge-base">
                              <QAOrdersKnowledgeBase />
                            </RouteGuard>
                          }
                        />
                        <Route path="/mapping">
                          <Route
                            path=""
                            element={
                              <RouteGuard url="mapping">
                                <ChatClassifier />
                              </RouteGuard>
                            }
                          />
                          {/* Страница проверки сметы и УПД — часть "Истории" */}
                          <Route
                            path="result/iterations"
                            element={
                              <RouteGuard url="mapping/result/iterations">
                                <MappingIterations />
                              </RouteGuard>
                            }
                          />
                          <Route
                            path="result/iteration/:id"
                            element={
                              <RouteGuard url="mapping/result/iterations">
                                <MappingIterationResults />
                              </RouteGuard>
                            }
                          />
                        </Route>
                        <Route
                          path="/demo"
                          element={
                            <RouteGuard url="demo">
                              <DemoSolution />
                            </RouteGuard>
                          }
                        />
                        <Route path="*" element={<HomeRedirect />} />
                      </Route>
                    </Routes>
                  </SidebarContextProvider>
                  {/* Цветные: белые уведомления сливались с белыми таблицами */}
                  <ToastContainer theme="colored" />
                </FavoriteMessageContextProvider>
              </ModeContextProvider>
            </UserContextProvider>
          </QueryClientProvider>
        </AuthContextProvider>
        {/* Вне AuthContextProvider: без входа он показывает только форму
            входа, а новая версия может выйти и пока она открыта */}
        <UpdateBanner />
      </ChakraProvider>
    </BrowserRouter>
  )
}
